import React, { useEffect, useRef } from 'react'
import { VariableSizeList } from 'react-window'
import PropTypes from 'prop-types'

import ListSubheader from '@material-ui/core/ListSubheader'

const LISTBOX_PADDING = 8

export const renderGroup = (params) => [
  <ListSubheader key={params.key} component="div">
    {params.group}
  </ListSubheader>,
  params.children,
]

const renderRow = (props) => {
  const { data, index, style } = props
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING,
    },
  })
}

const OuterElementContext = React.createContext({})

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext)
  return <div ref={ref} {...props} {...outerProps} />
})

function useResetCache(data) {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current !== null) ref.current.resetAfterIndex(0, true)
  }, [data])

  return ref
}

// Adapter for react-window
export const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props
  const itemData = React.Children.toArray(children)
  const itemCount = itemData.length
  const itemSize = 80

  const getChildSize = (child) => {
    if (React.isValidElement(child) && child.type === ListSubheader) return 48

    return itemSize
  }

  const getHeight = () => {
    if (itemCount > 6) return 6 * itemSize

    return itemData.map(getChildSize).reduce((a, b) => a + b, 0)
  }

  const listRef = useResetCache(itemCount)

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          ref={listRef}
          width="100%"
          height={getHeight() + 2 * LISTBOX_PADDING}
          itemData={itemData}
          itemSize={(index) => getChildSize(itemData[index])}
          itemCount={itemCount}
          overscanCount={5}
          outerElementType={OuterElementType}
          innerElementType="ul"
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  )
})

ListboxComponent.propTypes = {
  children: PropTypes.node,
}
